"use client";

import { Heading } from "@/components/atoms/Heading";
import NavigationList from "@/components/organisms/NavigationBar/navigationList";
import type { INavigationBarProps } from "@/components/organisms/NavigationBar/types";
import { useCategoriesQuery } from "@/hooks/apis/queries/useCategoriesQuery";
import { useTranslations } from "@/hooks/common/useTranslations";

const Navigation = ({ menu }: INavigationBarProps) => {
  const { t } = useTranslations("common");
  const { categories } = useCategoriesQuery(menu);

  return (
    <aside className="w-64 max-md:hidden" aria-label="Primary Navigation">
      <Heading size="h4" fontWeight="bold" className="px-6 mb-4">
        {t("category")}
      </Heading>
      <NavigationList list={categories} />
    </aside>
  );
};

Navigation.displayName = "Navigation";

export default Navigation;
